import { Component } from '@angular/core';

@Component({
    selector: 'trade-detail',
    styles: [],
    template: `<router-outlet></router-outlet>`
})

export class TradesComponent {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/trade/trade.component.ts